import React, { useEffect, useState } from "react";
import { api, track } from "@/lib/api";
import { BRAND } from "@/lib/brand";
import MakeCallForm from "@/components/MakeCallForm";
import CallCard from "@/components/CallCard";
import AdSlot from "@/components/AdSlot";
import { useAds, FEED_AD_INTERVAL } from "@/lib/ads";
import { Skeleton } from "@/components/ui/skeleton";

const SECTIONS = [
  ["trending", "🔥 Trending Calls"],
  ["latest", "🆕 Latest Calls"],
  ["recent_called", "🏆 Recently Called"],
  ["bold", "👀 Bold Calls"],
];

export default function Home() {
  const [feed, setFeed] = useState(null);
  const { slots } = useAds();

  useEffect(() => {
    track("homepage_viewed");
    api.get("/feed?section=all").then(({ data }) => setFeed(data)).catch(() => setFeed({}));
  }, []);

  return (
    <div className="max-w-2xl mx-auto px-4 pt-8 sm:pt-12">
      <div className="text-center mb-6">
        <h1 className="font-display text-4xl sm:text-6xl font-bold tracking-tighter leading-none">{BRAND.hero_title}</h1>
        <p className="text-base sm:text-lg text-muted-foreground mt-3 max-w-md mx-auto font-medium">{BRAND.hero_sub}</p>
      </div>

      <MakeCallForm />

      <div className="mt-14 space-y-12">
        {!feed && (
          <div className="space-y-4">
            {[1, 2, 3].map((i) => <Skeleton key={i} className="h-40 w-full border-2 border-ink" />)}
          </div>
        )}
        {feed && SECTIONS.map(([key, title]) => {
          const items = feed[key] || [];
          if (!items.length) return null;
          return (
            <section key={key} data-testid={`feed-section-${key}`}>
              <h2 className="font-display text-2xl font-bold tracking-tight mb-4">{title}</h2>
              <div className="space-y-5">
                {items.map((c, i) => (
                  <React.Fragment key={c.short_id}>
                    <CallCard call={c} />
                    {key === "latest" && (i + 1) % FEED_AD_INTERVAL === 0 && i < items.length - 1 && (
                      <AdSlot slot={slots.feed} format="auto" />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </section>
          );
        })}
        {feed && Object.values(feed).every((a) => !a?.length) && (
          <div className="text-center py-12 card-brutal bg-white">
            <p className="font-display text-2xl font-bold">No Calls yet</p>
            <p className="text-muted-foreground">Be the first to put something on the record.</p>
          </div>
        )}
      </div>
    </div>
  );
}
